// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"8499fccb","118":"3cb86443","369":"45fc52b4","736":"86dc11b2","787":"d62d1c65","802":"bf3bb824"}[chunkId] + ".chunk.js";
};